export const GET_ERRORS = 'GET_ERRORS'
export const RESET_ERRORS = 'RESET_ERRORS'
export const AUTH_MUTLTIFACTOR_MESSAGE = 'AUTH_MUTLTIFACTOR_MESSAGE'
export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const GET_CURRENT_USER = 'GET_CURRENT_USER'
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD'
export const AUTH_ALERT = 'AUTH_ALERT'
export const AUTH_LOGIN = 'AUTH_LOGIN'
export const GET_API_KEY = 'GET_API_KEY'
export const LOGIN_FLAG = 'LOGIN_FLAG'
export const REDIRECT_URL = 'REDIRECT_URL'

//USERS
export const GET_USERS_ERRORS = 'GET_USERS_ERRORS'
export const GET_USER = 'GET_USER'

//QSSERVER
export const GET_QSSERVER = 'GET_QSSERVER'
export const QSSERVER_LOADING = 'QSSERVER_LOADING'
export const SET_QSSERVER = 'SET_QSSERVER'
export const CLEAR_QSSERVER = 'CLEAR_QSSERVER'

//SITE SETTINGS
export const GET_SITE_LICENCE = 'GET_SITE_LICENCE'
export const SET_SITE_LICENCE = 'SET_SITE_LICENCE'
export const SITE_SETTINGS_LOADING = 'SITE_SETTINGS_LOADING'
export const GET_DECRYPTED_LICENCE = 'GET_DECRYPTED_LICENCE'
export const GET_PUBLIC_STATUS = 'GET_PUBLIC_STATUS'
export const GET_STRIPE_KEY = 'GET_STRIPE_KEY'
export const GET_SETTINGS_ERROR = ' GET_SETTINGS_ERROR'

//PAGES
export const GET_PAGES = 'GET_PAGES'
export const GET_SECURED_PAGES = 'GET_SECURED_PAGES'
export const GET_MENU_PAGES = 'GET_MENU_PAGES'
export const GET_PAGE = 'GET_PAGE'
export const GET_PAGE_DYNAMIC_APP = 'GET_PAGE_DYNAMIC_APP'
export const PAGES_LOADING = 'PAGES_LOADING'
export const RESET_PAGES = 'RESET_PAGES'
export const PAGE_ERRORS = 'PAGE_ERRORS'

//SECURITY GROUPS
export const GET_GROUPS = 'GET_GROUPS'
export const GET_GROUP = 'GET_GROUP'
export const GROUPS_LOADING = 'GROUPS_LOADING'

//OBJECTS
export const GET_OBJECTS = 'GET_OBJECTS'
export const GET_OBJECT = 'GET_OBJECT'
export const OBJECTS_LOADING = 'OBJECTS_LOADING'
export const CLEAR_OBJECTS = 'CLEAR_OBJECTS'

export const GET_CONTENT_ROWS = 'GET_CONTENT_ROWS'
export const GET_CONTENT_ROW = 'GET_CONTENT_ROW'

export const USERS_LOADING = 'USERS_LOADING'
export const GET_USERS = 'GET_USERS'
export const USER_QLIK_TICKET = 'USER_QLIK_TICKET'
export const GET_USER_BY_EMAIL = 'GET_USER_BY_EMAIL'

//QLIK SENSE
export const QLIK_LOADING = 'QLIK_LOADING'
export const GET_QLIK_CONNECTION = 'GET_QLIK_CONNECTION'
export const GET_QLIK_APPS = 'GET_QLIK_APPS'
export const GET_QLIK_APP = 'GET_QLIK_APP'
export const GET_QLIK_SHEETS = 'GET_QLIK_SHEETS'
export const GET_QLIK_OBJECTS = 'GET_QLIK_OBJECTS'
export const GET_QLIK_OBJECT = 'GET_QLIK_OBJECT'
export const RESET_QLIK_STATE = 'RESET_QLIK_STATE'
export const GET_QLIK_STREAMS = 'GET_QLIK_STREAMS'
export const GET_QLIK_SAAS_SPACES = 'GET_QLIK_SAAS_SPACES'
export const SET_QLIK_OPTIONS = 'SET_QLIK_OPTIONS'
export const CLEAR_QLIK_OPTIONS = 'CLEAR_QLIK_OPTIONS'
export const GET_QLIK_ERRORS = 'GET_QLIK_STREAMS_FAILED'

//LAYOUT TYPES
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'

//THEME TYPES
export const SET_THEME = 'SET_THEME'
export const GET_THEME = 'GET_THEME'
export const THEME_SHOW_MENU = 'THEME_SHOW_MENU'
export const THEME_LOADING = 'THEME_LOADING'
export const SIDEBAR_VISIBILITY = 'SIDEBAR_VISIBILITY'

// DYNAMIC APPLICATION GENERATION
export const SET_DAG_LOADING = 'SET_DAG_LOADING'
export const GET_MASTER_APPS = 'GET_MASTER_APPS'
export const GET_DYNAMIC_APPS = 'GET_DYNAMIC_APPS'
export const SET_DAG_FILTER_VALUE_USER = 'SET_DAG_FILTER_VALUE_USER'
export const SET_DAG_FILTER_VALUE = 'SET_DAG_FILTER_VALUE'
export const GET_MASTER_APPS_FAILED = 'GET_MASTER_APPS_FAILED'
export const SET_DAG_MASTER_APP = 'SET_DAG_MASTER_APP'
export const GET_DAG_MASTER_APP = 'GET_DAG_MASTER_APP'
export const GET_DAG_DYNAMIC_APP = 'GET_DAG_DYNAMIC_APP'
export const SET_DAG_FILTER = 'SET_DAG_FILTER'
export const GET_DAG_ERRORS = 'GET_DAG_ERRORS'
export const GET_DAG_FILTERS = 'GET_DAG_FILTERS'
export const GET_DAG_FILTER = 'GET_DAG_FILTER'
export const GET_DAG_FILTER_VALUE = 'GET_DAG_FILTER_VALUE'
export const GET_DAG_FILTER_VALUE_USERS = 'GET_DAG_FILTER_VALUE_USERS'
export const GET_DAG_FILTER_VALUE_DYNAMIC_APPS = 'GET_DAG_FILTER_VALUE_DYNAMIC_APPS'
export const RESET_DAG_STATE = 'RESET_DAG_STATE'

export const CREATE_MASTER_APP_SUCCESS = 'CREATE_MASTER_APP_SUCCESS'
export const CREATE_MASTER_APP_FAILED = 'CREATE_MASTER_APP_FAILED'

export const GET_AUTH_ALERT = 'GET_AUTH_ALERT'
export const SET_AUTH_ALERT = 'SET_AUTH_ALERT'
export const AUTH_ERRORS = 'AUTH_ERRORS'
export const AUTH_ERROR = 'AUTH_ERROR'
export const AUTH_PASSWORD_RESET_TOKEN = 'AUTH_PASSWORD_RESET_TOKEN'
export const AUTH_EMAIL_VERIFIED = 'AUTH_EMAIL_VERIFIED'
export const AUTH_GET_PRICING_CARDS = 'AUTH_GET_PRICING_CARDS'

export const SET_DATA_TABLE_ATTR = 'SET_DATA_TABLE_ATTR'
export const GET_DATA_TABLE_ATTR = 'GET_DATA_TABLE_ATTR'

export const SHOW_REGISTRATION = 'SHOW_REGISTRATION'
export const SHOW_SUBSCRIPTION = 'SHOW_SUBSCRIPTION'
export const SHOW_SUBSCRIPTION_WITH_USER = 'SHOW_SUBSCRIPTION_WITH_USER'
export const SHOW_PAYMENT = 'SHOW_PAYMENT'
export const SET_SELECTED_PRODUCT = 'SET_SELECTED_PRODUCT'
export const CREATE_STRIPE_CUSTOMER = 'CREATE_STRIPE_CUSTOMER'
export const SHOW_PAYMENT_SUCCESS = 'SHOW_PAYMENT_SUCCESS'

export const SUB_LOADING = 'SUB_LOADING'
export const SUB_ERRORS = 'SUB_ERRORS'
export const SET_SUBSCRIPTION = 'SET_SUBSCRIPTION'
export const SET_SUBSCRIPTIONS = 'SET_SUBSCRIPTIONS'

export const SET_ORGANISATIONS = 'SET_ORGANISATIONS'
export const SET_ORGANISATION_LOADING = 'SET_ORGANISATION_LOADING'
export const SET_ORGANISATION = 'SET_ORGANISATION'
export const UPDATE_ORGANISATION = 'UPDATE_ORGANISATION'
export const CREATE_ORGANISATION = 'CREATE_ORGANISATION'
export const DELETE_ORGANISATION = 'DELETE_ORGANISATION'
export const SET_ORG_ERRORS = 'SET_ORG_ERRORS'
export const SET_SELECTED_ORG = 'SET_SELECTED_ORG'
export const RESET_SELECTED_ORG = 'RESET_SELECTED_ORG'

export const GET_SHORTLISTS = 'GET_SHORTLISTS'
export const SET_SHORTLISTS_LOADING = 'SET_SHORTLISTS_LOADING'
export const GET_SHORTLIST = 'GET_SHORTLIST'
export const SET_SHORTLIST_ERRORS = 'SET_SHORTLIST_ERRORS'
export const GET_SHORTLIST_SHARE_OPTIONS = 'GET_SHORTLIST_SHARE_OPTIONS'

export const GET_SIMULATOR_RESULTS = 'GET_SIMULATOR_RESULTS'
export const CLEAR_SIMULATOR_RESULTS = 'CLEAR_SIMULATOR_RESULTS'
export const SET_SIMULATOR_ERROR = 'SET_SIMULATOR_ERROR'
export const SET_SIMULATOR_LOADING = 'SET_SIMULATOR_LOADING'
export const SET_SIMULATOR_REQUEST = 'SET_SIMULATOR_REQUEST'

export const FILE_UPLOAD_ERROR = 'FILE_UPLOAD_ERROR'
export const FILE_UPLOAD_LOADING = 'FILE_UPLOAD_LOADING'
export const FILE_UPLOAD_PROGRESS = 'FILE_UPLOAD_PROGRESS'
export const FILE_UPLOAD_RESPONSE = 'FILE_UPLOAD_RESPONSE'
export const RESET_FILE_UPLOAD = 'RESET_FILE_UPLOAD'
